import React, { useCallback, useContext } from "react";
import "./index.css";
import {
    Badge,
    Button,
    ButtonGroup,
    ButtonToolbar,
    Col,
    Row,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import { QuestionarioContext } from "../../../../../contexts/QuestionarioContext";
import QuestionarioService from "../../../../../services/QuestionarioService";
import { successToast } from "../../../../../components/DommusToast";
import DommusSwitchControl from "../../../../../components/DommusSwitchControl";

export function PerguntaCard({ pergunta }) {
    const { atualizarPergunta, removerPergunta } = useContext(QuestionarioContext);    

    const handleAlterarPergunta = (dados) => {        
        trackPromise(
            QuestionarioService.alterarStatusPergunta(
                pergunta.id_questionario,
                pergunta.id_pergunta,
                dados
            )
        )
            .then((response) => {
                atualizarPergunta(response.data);
                successToast.fire("Pergunta atualizada com sucesso!!");
            })
            .catch((erro) => {
                Swal.fire({
                    titleText: "Ooops...",
                    text:`Houve um erro ao remover a pergunta. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
                    icon: "error",
                });
            });
    };

    const handleRemovePergunta = (pergunta) => {
        Swal.fire({
            title: "Deseja realmente excluir esta pergunta?",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar!",
        }).then((result) => {
            if (result.isConfirmed) {
                trackPromise(
                    QuestionarioService.deletePergunta(
                        pergunta.id_questionario,
                        pergunta.id_pergunta
                    )
                )
                    .then(() => {
                        removerPergunta(pergunta);
                        successToast.fire("Pergunta removido com sucesso!!");
                    })
                    .catch((erro) => {
                        Swal.fire({
                            titleText: "Ooops...",
                            text:`Houve um erro ao remover a pergunta. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
                            icon: "error",
                        });
                    });
            }
        });
    };

    const handleMontarResposta = useCallback(
        (options) => {
            if (Array.isArray(options)) {
                return options.map((option, index) => {
                    return (
                        <Badge key={index} variant="info">
                            {option?.label}
                        </Badge>
                    );
                });
            } 
        },
        [pergunta]
    );

    return (
        <Row className="pergunta-card">
            <Col md="8" className="info">
                <div className="enunciado-section">
                    <span style={{ color: "#999", fontSize: "14px" }}>Enunciado</span>
                    {pergunta.pergunta.enunciado}
                </div>
                <span className="tipo-resposta">
                    Tipo Respostas: {pergunta.pergunta?.tipo_resposta_pergunta?.nome}
                </span>
                <div className="respostas-section">
                    {handleMontarResposta(pergunta.pergunta.options)}
                </div>
            </Col>
            <Col md="4" className="acao-section align-self-center">
                <Row className="justify-content-end align-items-center">
                    <DommusSwitchControl
                        labelInativo="Obrigatório"
                        checked={pergunta.obrigatorio}
                        tooltip={`${pergunta.obrigatorio ? 'Sim' : 'Não'}`}
                        labelAtivo=""
                        onChange={(event)=>{
                            const dados = {
                                obrigatorio: Number(event.target.checked).toString()
                            }
                            handleAlterarPergunta(dados);
                        }}
                    />
                    <ButtonToolbar
                        aria-label="Toolbar with button groups"
                        className="justify-content-end"
                    >
                        <ButtonGroup
                            className="btn-group-toggle"
                            aria-label="First group"
                        >
                            <button
                                onClick={() => {
                                    const dados = {
                                        oculto: !pergunta.oculto,
                                    };
                                    handleAlterarPergunta(dados);
                                }}
                                className={`btn ${pergunta.oculto
                                        ? "btn-secondary"
                                        : "btn-success borderBtnAtivo"
                                    }`}
                            >
                                Ativo
                            </button>
                            <button
                                onClick={() => {
                                    const dados = {
                                        oculto: !pergunta.oculto,
                                    };
                                    handleAlterarPergunta(dados);
                                }}
                                className={`btn ${pergunta.oculto
                                        ? "btn-danger borderBtnAtivo"
                                        : "btn-secondary"
                                    }`}
                            >
                                Inativo
                            </button>
                        </ButtonGroup>
                    </ButtonToolbar>
                    <Button
                        variant="danger"
                        className="ml-3"
                        onClick={() => {
                            handleRemovePergunta(pergunta);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </Button>
                </Row>
            </Col>
        </Row>
    );
}
